import { IOffer } from '../../repositories/dailyrent/entities/offer/Offer';

/**
 * Объявление с минимальной ценой за сутки - его цена стоит на пине «от».
 * Нулевые цены не считаются; при равных ценах - первое по порядку.
 */
export function getMinPriceOffer(offers: IOffer[]): IOffer | null {
  return offers.reduce<IOffer | null>((minPriceOffer, offer) => {
    if (!offer.averagePricePerDay) {
      return minPriceOffer;
    }

    return !minPriceOffer || offer.averagePricePerDay < minPriceOffer.averagePricePerDay ? offer : minPriceOffer;
  }, null);
}
